const VARIANTS = {
  yes: "success",
  no: "neutral",
  blocked: "danger",
  pending: "warning",
  active: "success",
};

const YesNoBadge = ({ value, trueText = "Yes", falseText = "No", variant = "yes", falseVariant = "no" }) => {
  const tone = value ? VARIANTS[variant] || "success" : VARIANTS[falseVariant] || VARIANTS.no;
  return (
    <span className={`dashboard-badge dashboard-badge--${tone}`}>{value ? trueText : falseText}</span>
  );
};

export default YesNoBadge;
